/**
 * Some constants for using in the foerdermittelcheck
 */
export class FoerdermittelcheckConstants {
  // number of days for the validity of the local storage data
  static readonly LOCALSTORAGE_TIMEOUT_DAYS = 2;

  // breakpoints for window resize
  static readonly BREAKPOINT_SMALL_SCREEN = 640;
  static readonly BREAKPOINT_MEDIUM_SCREEN = 870;

  // items per page in pagination of programs table
  static readonly ITEMS_PER_PAGE = 10;
  static readonly ITEMS_PER_PAGE_SMALL_SCREEN = 6;
}
